/*
  ============================================================
  BOVEA GIFT ENGINE
  Datei: assets/bovea-gift-engine.js

  Die komplette Warenkorb-Logik an einer Stelle und ohne
  Seiteneffekte. plan() rechnet nur, run() fuehrt aus.
  Dadurch laesst sich die Logik testen, ohne einen echten
  Shopify-Warenkorb zu brauchen.

  Grundregeln
  1. Eine Zeile ist genau dann ein Geschenk, wenn sie die
     Markierung _bovea_gift traegt. Sonst nie.
  2. Geschenkzeilen haben immer exakt Menge 1.
  3. Shopify darf eine bezahlte Variante intern wegen
     automatischer Rabatte auf mehrere Zeilen aufteilen. Fuer
     Anzeige und Bedienung werden diese Zeilen nur virtuell zu
     einer gemeinsamen Produktzeile zusammengefasst.
  4. Kauft der Kunde denselben Artikel, den es auch als
     Geschenk gibt, bleibt das eine ganz normale bezahlte
     Zeile. Die wird nie angefasst und nie gratis.
  5. Nur bezahlte Zeilen zaehlen fuer die Schwelle.
  6. Preisbasis ist ueberall original_price, also der
     regulaere Stueckpreis vor Warenkorbrabatten. Damit
     rechnen Leiste, Drawer und Schwelle mit derselben Zahl.
  ============================================================
*/

(function (root, factory) {
  var api = factory();

  if (
    typeof module === "object" &&
    module.exports
  ) {
    module.exports = api;
  } else {
    root.BoveaGiftEngine = api;
  }
})(
  typeof self !== "undefined" ? self : this,
  function () {
    "use strict";

    var GIFT_PROPERTY = "_bovea_gift";
    var COSMETIC_PROPERTY = "_bovea_subtitle";

    /* Markierungen aus frueheren Versionen weiter erkennen. */
    var LEGACY_PROPERTIES = {
      _bovea_free_gift: "magclip",
      _bovea_threshold_gift: "towels"
    };

    function giftKindOf(item) {
      if (!item || !item.properties) {
        return "";
      }

      var flag = String(
        item.properties[GIFT_PROPERTY] || ""
      );

      if (flag) {
        return flag;
      }

      var legacy = "";

      Object.keys(LEGACY_PROPERTIES).forEach(
        function (name) {
          if (legacy) {
            return;
          }

          if (
            String(item.properties[name] || "") ===
            "true"
          ) {
            legacy = LEGACY_PROPERTIES[name];
          }
        }
      );

      return legacy;
    }

    function isGift(item) {
      return giftKindOf(item) !== "";
    }

    /*
      Regulaerer Stueckpreis vor Warenkorbrabatten. Bewusst
      nicht final_price: Shopify verteilt einen automatischen
      Rabatt sonst quer und die selbst gekaufte Kopie des
      Geschenks saehe gratis aus.
    */
    function unitPrice(item) {
      if (!item) {
        return 0;
      }

      if (typeof item.original_price === "number") {
        return item.original_price;
      }

      if (typeof item.price === "number") {
        return item.price;
      }

      var quantity = Math.max(
        Number(item.quantity || 1),
        1
      );

      if (typeof item.original_line_price === "number") {
        return Math.round(
          item.original_line_price / quantity
        );
      }

      return 0;
    }

    /*
      Was der Kunde fuer die Zeile wirklich zahlt, inklusive
      automatischer Rabatte. Nur fuer die Summe unten im
      Drawer, nie fuer die Schwelle.
    */
    function paidLinePrice(item) {
      if (!item) {
        return 0;
      }

      if (typeof item.final_line_price === "number") {
        return item.final_line_price;
      }

      if (typeof item.line_price === "number") {
        return item.line_price;
      }

      return (
        unitPrice(item) *
        Math.max(Number(item.quantity || 0), 0)
      );
    }

    /*
      Zeilenidentitaet. Bezahlte Zeilen derselben Variante
      gehoeren immer zusammen, egal welche Eigenschaften an
      ihnen haengen. Genau das verhindert die aufgespaltenen
      Doppelzeilen.
    */
    function variantKeyOf(item) {
      return String(item && item.variant_id);
    }

    /*
      Aus Kompatibilitaet erhalten, wird zum Zusammenfuehren
      nicht mehr benutzt.
    */
    function signatureOf(item) {
      var properties = (item && item.properties) || {};

      var relevant = Object.keys(properties)
        .filter(function (name) {
          return (
            name !== COSMETIC_PROPERTY &&
            name !== GIFT_PROPERTY
          );
        })
        .sort()
        .map(function (name) {
          return name + "=" + String(properties[name]);
        });

      return (
        String(item && item.variant_id) +
        "|" +
        relevant.join(";")
      );
    }

    function itemsOf(cart) {
      return cart && Array.isArray(cart.items)
        ? cart.items
        : [];
    }

    /* Alle bezahlten Zeilen mit Menge groesser null. */
    function paidItems(cart) {
      return itemsOf(cart).filter(function (item) {
        return (
          !isGift(item) &&
          Number(item.quantity || 0) > 0
        );
      });
    }

    /*
      Grundlage der Schwelle und der Anzeige "bereits im
      Warenkorb". Immer regulaere Stueckpreise.
    */
    function paidTotal(cart) {
      return paidItems(cart).reduce(
        function (sum, item) {
          return (
            sum +
            unitPrice(item) *
            Number(item.quantity || 0)
          );
        },
        0
      );
    }

    /*
      Findet die bezahlte Zeile einer Variante. Gibt es
      mehrere, gewinnt die erste. Der Aufrufer arbeitet immer
      mit einem frisch geholten Warenkorb, damit der
      Zeilenschluessel nicht veraltet sein kann.
    */
    function findPaidLine(cart, variantId) {
      var wanted = String(variantId);
      var found = null;

      itemsOf(cart).forEach(function (item) {
        if (
          found ||
          isGift(item) ||
          variantKeyOf(item) !== wanted
        ) {
          return;
        }

        found = item;
      });

      return found;
    }

    function paidQuantity(cart, variantId) {
      var wanted = String(variantId);

      return itemsOf(cart).reduce(function (sum, item) {
        if (
          isGift(item) ||
          variantKeyOf(item) !== wanted
        ) {
          return sum;
        }

        return sum + Number(item.quantity || 0);
      }, 0);
    }

    /*
      Shopify kann eine Variante wegen automatischer Rabatte in
      mehrere Zeilen aufteilen. Diese Funktion berechnet eine
      einzige /cart/update.js-Nutzlast, die nur so viele echte
      Zeilen wie noetig veraendert und die Gesamtmenge exakt auf
      den Zielwert bringt. Geschenkzeilen bleiben unberuehrt.

      Rueckgabe:
      - null: Es existiert noch keine bezahlte Zeile; der Artikel
              muss ueber /cart/add.js angelegt werden.
      - {}:   Die Zielmenge ist bereits erreicht.
      - Objekt mit line-item-keys fuer /cart/update.js.
    */
    function paidQuantityUpdates(cart, variantId, targetQuantity) {
      var wanted = String(variantId);
      var target = Math.max(Number(targetQuantity || 0), 0);

      var lines = itemsOf(cart).filter(function (item) {
        return (
          !isGift(item) &&
          variantKeyOf(item) === wanted &&
          Number(item.quantity || 0) > 0
        );
      });

      if (!lines.length) {
        return target > 0 ? null : {};
      }

      var current = lines.reduce(function (sum, item) {
        return sum + Number(item.quantity || 0);
      }, 0);

      if (current === target) {
        return {};
      }

      var updates = {};

      if (target > current) {
        updates[lines[0].key] =
          Number(lines[0].quantity || 0) +
          (target - current);

        return updates;
      }

      var remove = current - target;

      for (
        var index = lines.length - 1;
        index >= 0 && remove > 0;
        index -= 1
      ) {
        var line = lines[index];
        var quantity = Number(line.quantity || 0);
        var nextQuantity = Math.max(quantity - remove, 0);

        updates[line.key] = nextQuantity;
        remove -= quantity - nextQuantity;
      }

      return updates;
    }

    /*
      Reine Anzeige-Zusammenfassung: Geschenkzeilen bleiben
      einzeln, alle bezahlten Zeilen derselben Variante werden
      zu genau einer sichtbaren Produktzeile addiert. Der echte
      Shopify-Warenkorb wird dabei nicht veraendert.
    */
    function displayItems(cart) {
      var result = [];
      var paidByVariant = {};

      itemsOf(cart).forEach(function (item) {
        if (isGift(item)) {
          result.push(item);
          return;
        }

        var variantId = variantKeyOf(item);
        var aggregate = paidByVariant[variantId];

        if (!aggregate) {
          aggregate = {};

          Object.keys(item).forEach(function (name) {
            aggregate[name] = item[name];
          });

          aggregate.quantity = 0;
          aggregate.original_line_price = 0;
          aggregate.final_line_price = 0;
          aggregate.line_price = 0;
          aggregate.total_discount = 0;
          aggregate._bovea_line_keys = [];

          paidByVariant[variantId] = aggregate;
          result.push(aggregate);
        }

        aggregate.quantity += Number(item.quantity || 0);
        aggregate.original_line_price += Number(
          item.original_line_price || 0
        );
        aggregate.final_line_price += Number(
          item.final_line_price || 0
        );
        aggregate.line_price += Number(item.line_price || 0);
        aggregate.total_discount += Number(
          item.total_discount || 0
        );

        if (item.key) {
          aggregate._bovea_line_keys.push(item.key);
        }
      });

      return result;
    }

    /*
      Rechnet den Sollzustand aus und gibt die noetigen
      Schritte zurueck. Aendert nichts.
    */
    function plan(cart, config) {
      var ops = [];

      var items = itemsOf(cart);

      var limit = Number(
        (config && config.limit) || 0
      );

      var gifts =
        config && Array.isArray(config.gifts)
          ? config.gifts
          : [];

      /*
        Arbeitsmodell aufbauen. Bezahlte Zeilen werden hier
        bewusst NICHT physisch zusammengefuehrt: Shopify darf
        sie fuer automatische Rabatte intern aufteilen. Die
        sichtbare Zusammenfassung erledigt displayItems().
      */
      var lines = items.map(function (item) {
        return {
          key: item.key,
          variantId: variantKeyOf(item),
          quantity: Math.max(
            Number(item.quantity || 0),
            0
          ),
          unit: unitPrice(item),
          kind: giftKindOf(item),
          alive: true
        };
      });

      /* Schritt 1: Grundlage fuer die Schwelle. */
      var livePaid = lines.filter(function (line) {
        return (
          !line.kind &&
          line.alive &&
          line.quantity > 0
        );
      });

      var total = livePaid.reduce(
        function (sum, line) {
          return sum + line.unit * line.quantity;
        },
        0
      );

      var hasPaid = livePaid.length > 0;

      /* Schritt 2: jede Geschenkstufe auf Soll bringen. */
      gifts.forEach(function (gift) {
        var want =
          gift.requires === "threshold"
            ? hasPaid && total >= limit
            : hasPaid;

        var own = lines.filter(function (line) {
          return line.kind === gift.kind && line.alive;
        });

        if (!want) {
          own.forEach(function (line) {
            ops.push({
              op: "change",
              key: line.key,
              quantity: 0
            });
          });

          return;
        }

        if (!own.length) {
          if (!gift.variantId) {
            return;
          }

          var properties = {};

          properties[GIFT_PROPERTY] = gift.kind;

          if (gift.subtitle) {
            properties[COSMETIC_PROPERTY] = gift.subtitle;
          }

          ops.push({
            op: "add",
            variantId: Number(gift.variantId),
            quantity: 1,
            properties: properties
          });

          return;
        }

        own.slice(1).forEach(function (line) {
          ops.push({
            op: "change",
            key: line.key,
            quantity: 0
          });
        });

        if (own[0].quantity !== 1) {
          ops.push({
            op: "change",
            key: own[0].key,
            quantity: 1
          });
        }
      });

      return ops;
    }

    /* Fuehrt die Schritte streng nacheinander aus. */
    function run(ops, api) {
      if (!ops || !ops.length) {
        return api.get();
      }

      return ops
        .reduce(function (chain, op) {
          return chain.then(function () {
            if (op.op === "add") {
              return api.add({
                id: op.variantId,
                quantity: op.quantity,
                properties: op.properties
              });
            }

            return api.change({
              id: op.key,
              quantity: op.quantity
            });
          });
        }, Promise.resolve())
        .then(function () {
          return api.get();
        });
    }

    /*
      Plan ausfuehren und danach pruefen, ob der Warenkorb
      wirklich sauber ist. Zwei Durchgaenge reichen: der
      erste kann auf veralteten Daten gelaufen sein, der
      zweite laeuft auf frischen.
    */
    function settle(cart, config, api, depth) {
      var round = Number(depth || 0);

      if (round >= 3) {
        return Promise.resolve(cart);
      }

      var ops = plan(cart, config);

      if (!ops.length) {
        return Promise.resolve(cart);
      }

      return run(ops, api).then(function (fresh) {
        return settle(fresh, config, api, round + 1);
      });
    }

    /*
      Summen fuer die Warenkorbanzeige.
      Zwischensumme : alle Vergleichspreise
      Gesamt        : was der Kunde wirklich zahlt
      Rabatte       : die Differenz, enthaelt damit auch
                      die Geschenkwerte und einen
                      automatischen Warenkorbrabatt
      Der durchgestrichene Versand bleibt bewusst draussen.
    */
    function totals(cart, giftValues) {
      var subtotal = 0;
      var total = 0;

      itemsOf(cart).forEach(function (item) {
        var quantity = Math.max(
          Number(item.quantity || 0),
          0
        );

        var kind = giftKindOf(item);

        if (kind) {
          subtotal +=
            Number((giftValues || {})[kind] || 0) *
            quantity;

          return;
        }

        var unit = unitPrice(item);

        var compare = Number(
          item.bovea_compare_at || 0
        );

        if (compare <= unit) {
          compare = unit;
        }

        subtotal += compare * quantity;
        total += paidLinePrice(item);
      });

      if (subtotal < total) {
        subtotal = total;
      }

      return {
        subtotal: subtotal,
        total: total,
        savings: Math.max(subtotal - total, 0)
      };
    }

    return {
      GIFT_PROPERTY: GIFT_PROPERTY,
      COSMETIC_PROPERTY: COSMETIC_PROPERTY,
      giftKindOf: giftKindOf,
      isGift: isGift,
      unitPrice: unitPrice,
      paidLinePrice: paidLinePrice,
      signatureOf: signatureOf,
      variantKeyOf: variantKeyOf,
      paidItems: paidItems,
      paidTotal: paidTotal,
      findPaidLine: findPaidLine,
      paidQuantity: paidQuantity,
      paidQuantityUpdates: paidQuantityUpdates,
      displayItems: displayItems,
      plan: plan,
      run: run,
      settle: settle,
      totals: totals
    };
  }
);
